import type { Directive } from 'vue';

export const plainTextPasteDirective: Directive = {
   mounted(el: HTMLElement) {
      const handlePaste = (event: ClipboardEvent) => {
         event.preventDefault();
         event.stopPropagation();

         const text = event.clipboardData?.getData('text/plain');
         if (!text) return;

         const selection = window.getSelection();
         if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            const textNode = document.createTextNode(text);
            range.insertNode(textNode);
            selection.removeAllRanges();
         }
      };

      (el as any)._plainTextPasteHandler = handlePaste;
      el.addEventListener('paste', handlePaste, true);
   },

   unmounted(el: HTMLElement) {
      const handler = (el as any)._plainTextPasteHandler;
      if (handler) {
         el.removeEventListener('paste', handler, true);
         delete (el as any)._plainTextPasteHandler;
      }
   },
};
